import { useTranslation } from 'react-i18next';
import { useGetWarehouseAddress } from '@steelbuy/data-access';
import { AddressLine, Country, getFormattedAddress } from '@steelbuy/ts-shared';
import { Tooltip, TooltipType } from '@steelbuy/ui-primitive';

export const CollectionAddressCell = ({ addressId }: { addressId: string }) => {
    const { data } = useGetWarehouseAddress();
    const { t } = useTranslation(['domainModel']);

    const addressInfo = data?.find((address) => address.id === addressId);

    if (!addressInfo) return null;

    const formattedAddressParts = getFormattedAddress({
        addressLine1: addressInfo.addressLine1,
        city: addressInfo.city,
        name: addressInfo?.name,
        postalCode: addressInfo?.postalCode,
        country: addressInfo?.country,
    }).map(({ value, addressLine }) =>
        addressLine === AddressLine.COUNTRY ? t(`domainModel:address.country.${value as Country}`) : value
    );

    const formattedAddress =
        formattedAddressParts.length > 1
            ? `${formattedAddressParts[0]}. ${formattedAddressParts.slice(1).join(', ')}`
            : formattedAddressParts[0] ?? '';

    return (
        <Tooltip content={formattedAddress} type={TooltipType.INFO}>
            <td className="bulk-listing-table__table__has-max-width">{formattedAddress}</td>
        </Tooltip>
    );
};
